module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active),
      expression: "active"
    }],
    attrs: {
      "id": "tc"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "swoosh"
  }, [_c('swoosh-icon')], 1), _vm._m(0), _vm._m(1), _c('p', [_vm._v("本次活动时间，自2017年6月8日0时开始至7月5日24时结束。在活动开始前或者活动结束后参与活动均属无效。 ")]), _c('p', [_vm._v("用户只需以尽快速度滑动屏幕，完成线上比赛，即可获得“突破速度挑战赛”定制T恤抽奖机会。")]), _vm._m(2), _c('p', [_vm._v("活动奖品：“突破速度挑战赛”定制T恤一件（共20件）")]), _c('p', [_vm._v("用户完成比赛后，即可点击进入抽奖参与页面，留下个人联系方式。")]), _c('p', [_vm._v("我们将于7月6日抽取20名获奖者，每位获奖者将获赠“突破速度挑战赛”定制T恤一件。届时，我们将致电联系中奖者一一告知中奖信息及领奖方式。")]), _c('h3', [_vm._v("关于以上所有奖品：")]), _vm._m(3), _vm._m(4), _vm._m(5)]), _c('div', {
    staticClass: "close-button",
    on: {
      "click": _vm.close
    }
  }, [_c('CloseIcon')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('p', [_vm._v("NIKE“突破速度挑战赛”")]), _c('p', [_vm._v("线上活动须知")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('img', {
    staticClass: "bg",
    attrs: {
      "src": require("assets/result/btn-blue.png")
    }
  }), _c('div', {
    staticClass: "label"
  }, [_c('span', [_vm._v("活动规则")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('img', {
    staticClass: "bg",
    attrs: {
      "src": require("assets/result/btn-blue.png")
    }
  }), _c('div', {
    staticClass: "label"
  }, [_c('span', [_vm._v("奖品说明")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("中奖者留下的个人信息需真实准确，并保持手机畅通。若因客观原因无法顺利联系到获奖者，此获奖资格将作废。")]), _c('li', [_vm._v("获奖资格不得转让，亦不能兑换现金或者其他等价物。本次活动的奖品不设调换。但主办方保留在法律允许的范围内，如因奖品无法提供或者主办方自主判决的其他原因不能提供的情况下，替换其他相同或者更高金额的奖品的权利。获奖者应负责上述未明确列明由主办方承担的其他税费。")]), _c('li', [_vm._v("如果获奖者拒绝接受奖品，不符合参与条件或者有违反本次活动《活动须知》的情况，主办方有权立即取消获奖者的中奖资格，并另行选择获奖者。")]), _c('li', [_vm._v("在法律允许的范围内，主办方有权对获奖者是否符合参与及中奖资格进行独立判断，并做出最终决定。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('img', {
    staticClass: "bg",
    attrs: {
      "src": require("assets/result/btn-blue.png")
    }
  }), _c('div', {
    staticClass: "label"
  }, [_c('span', [_vm._v("其他")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("本次活动由耐克体育（中国）有限公司主办。")]), _c('li', [_vm._v("未经主办方许可，参加者不得利用本次参加事宜或参加活动本身进行任何形式的商业性或非商业性的市场开发或宣传活动等。")]), _c('li', [_vm._v("参加者同意主办方可以为组织本次活动的目的收集并且授权第三方使用其个人信息。")]), _c('li', [_vm._v("主办方不对因网络传输原因而导致参加者提交的信息丢失或错误承担任何责任。如遇不可抗力，包括但不限于自然灾害、天气原因、罢工、网络故障、政府临时管制、恐怖活动等因素导致本次活动因故无法进行时，主办方有权在法律允许的范围内决定取消、终止、修改或暂停本次活动。届时，主办方将另行通知相关事宜。")]), _c('li', [_vm._v("在法律允许的范围内，耐克体育（中国）有限公司拥有对本次活动的最终解释权。")]), _c('li', [_c('span', [_vm._v("参加者的个人信息保护：通过本次活动收集的个人信息均适用耐克的个人信息保护政策，你可以阅读")]), _c('a', {
    attrs: {
      "href": "http://help-zh-cn.nike.com/app/answers/detail/article/privacy-policy/a_id/16423/p/3897"
    }
  }, [_vm._v("《耐克网络隐私政策》")]), _c('span', [_vm._v("获取更多信息。")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d2d73ec0"}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tc/Tc.vue
// module id = 459
// module chunks = 1